export default __webpack_public_path__ + "static/media/court-1.68ea076e.png";